import { render, staticRenderFns } from "./SuperAdminDeviceList.vue?vue&type=template&id=12a79f3e&scoped=true&"
import script from "./SuperAdminDeviceList.vue?vue&type=script&lang=js&"
export * from "./SuperAdminDeviceList.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminDeviceList.vue?vue&type=style&index=0&id=12a79f3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a79f3e",
  null
  
)

export default component.exports